<div class="master-data-container">
  <div class="master-data-toolbar">
    <ul class="tab tab-pills">
      <li routerLink="system-mapping" routerLinkActive="active"
          (mouseenter)="systemMappingHover = true" (mouseleave)="systemMappingHover = false">
        <a [ngClass]="{ activeTab: rla.isActive, inactiveTab: !rla.isActive && systemMappingHover }"
           routerLinkActive #rla="routerLinkActive">System To Form Mapping</a>
      </li>
    </ul>
  </div>
  <hr class="tab-separator" />

  <router-outlet></router-outlet>
</div>
